import Handlebars from '@sparta.global.vendors/handlebars';

/**
 * Tagline helper takes an array of tagline copy and appropriately
 * applies spaces and forward slashes to seperate words.
 *
 * @param {any} taglineArray
 * @returns
 */
function tagline(taglineArray) {
  var minTags = 2;
  var maxTags = 3;
  var tagOpen = '<span class="spa-tagline">';
  var tagClose = '</span>';
  var renderedTagline = '';
  if (Array.isArray(taglineArray) && taglineArray.length >= minTags && taglineArray.length <= maxTags) {
    renderedTagline = new Handlebars.SafeString("".concat(tagOpen).concat(taglineArray.join('&nbsp;/ ')).concat(tagClose));
  } else {
    throw new Error("Tagline JCR must be an array with at least ".concat(minTags, " and no more than ").concat(maxTags, " string values"));
  }
  return renderedTagline;
}

/**
 * Register the TaglineHelper with Handlebars
 *
 * @class TaglineHelper
 */

export { tagline };